"use client";

import { useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import * as Flex from "@repo/ui/flex";
import { ComponentProps } from "../../types/component-props";
import { SearchProvider } from "../customer-care/components/search";
import Placeholder from "../placeholder-component/placeholder";
import styles from "./partial-design-component.module.css";

type PartialComponentProps = ComponentProps & {
  classname: string;
};

const PartialDesignDynamicPlaceholder = (
  props: PartialComponentProps,
): JSX.Element => {
  const placeholders = props.rendering?.placeholders || {};
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!placeholders) {
    if (!isEditing) {
      return <></>;
    }
  }

  return (
    <SearchProvider>
      {placeholders &&
        Object.entries(placeholders).map(([key]) => {
          const isAside = key.includes("aside");
          return (
            <Flex.Container
              justify={"start"}
              align={!isEditing ? "start" : undefined}
              key={`${props.rendering.uid}-${key}`}
              column
              className={styles[props.classname]}
              asChild={isAside}
            >
              {isAside ? (
                <aside className={styles.asidePlaceholder}>
                  <Placeholder
                    name={key}
                    rendering={props.rendering}
                    isAside={isAside}
                  />
                </aside>
              ) : (
                <Placeholder
                  name={key}
                  rendering={props.rendering}
                  classname={props.classname}
                />
              )}
            </Flex.Container>
          );
        })}
    </SearchProvider>
  );
};

export default PartialDesignDynamicPlaceholder;
